export const CONFIGURATIONS_PATH = '/settings/remote-storage/configurations';
export const ACCESSION_TABLES_PATH = '/settings/remote-storage/accession-tables';

export const API_PATH = 'remote-storage';

export const DEMATIC_SD = 'DEMATIC_SD';
export const DEMATIC_EMS = 'DEMATIC_EMS';
export const CAIASOFT = 'CAIA_SOFT';
